import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = ["id", "data-bs-target", "aria-controls", "aria-selected", "data-story-type"]
const _hoisted_3 = { class: "row wrapper-colls" }
const _hoisted_4 = { class: "col-4 col-img disable-context-menu" }
const _hoisted_5 = ["id"]
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "col-8 col-content" }
const _hoisted_9 = {
  key: 0,
  class: "nav-title"
}
const _hoisted_10 = { class: "playlist-nav-item-story-title" }
const _hoisted_11 = { class: "col-sm-6" }

import { PlaylistConstants, PlaylistStoryDto } from '@/models/PlaylistPageTypes'
import { ref, onMounted } from 'vue'
import { usePlaylistStore } from '@/stores/playlistStore'
import { STORY_TYPE } from '@/models/StoryTypeEnum'


export default /*#__PURE__*/_defineComponent({
  __name: 'PLaylistPageListOfStoriesListElement',
  props: {
    story: null,
    stories: null
  },
  setup(__props: any) {

const props = __props as {
    story?: PlaylistStoryDto
    stories?: Array<PlaylistStoryDto>
};

const tabsButtons = ref<Array<HTMLElement> | undefined>(undefined)
const playlistStore = usePlaylistStore()



function SetTimerCycle(story: PlaylistStoryDto) {
    const currentElement = document.getElementById(story.KeyId + '-nav-item');
    const playlistNavs = [...document.getElementsByClassName("playlist-nav-item")];
    playlistNavs.forEach(el => el.classList.remove("playlist-nav-item-active"))
    currentElement?.classList.add("playlist-nav-item-active")

    const videoElements = document.querySelectorAll("video"); 
    videoElements.forEach((element) => {
        if(element.id !== `${props.story?.KeyId}-player`)
        {
            element.pause()
        }
    })

    if (story.Type == STORY_TYPE.Video || story.Type == STORY_TYPE.Audio) {
        const video = document.getElementById(props.story?.KeyId + '-player') as HTMLVideoElement
        if (video)
        {
            video.onplay = () => {
                setVideoProgress(video, story)
            }
        }

        window.clearInterval(playlistStore.autoplayTimer)
        return
    }
    playlistStore.SetTimerCycle(props.stories, story);
}

function convertTime(time: number) {
    if (!time) {
        return null;
    }
    let hours = Math.floor(time / 3600000);
    let minutes = Math.floor((time % 3600000) / 60000);
    let seconds = Math.floor((time % 60000) / 1000);
    
    return (
        (hours > 0 ? hours.toString().padStart(2, '0') + ":" : "") +
        minutes.toString().padStart(2, '0') + ":" +
        seconds.toString().padStart(2, '0')
    );
}

function setVideoProgress(video: HTMLVideoElement, story: PlaylistStoryDto) {
    const progress = document.getElementById(story?.KeyId + '-progress') as HTMLInputElement
    const element = document.getElementById(story.KeyId)?.parentElement?.nextElementSibling?.firstChild as HTMLElement
    video.onpause = () => clearInterval(localTimer)
    if (element) {
        video.onended = () => element.click()
    }

    let localTimer = setInterval(() => {
        progress.value = `${Math.round(((video.currentTime*1000) / story.ViewDuration) * 100)}`
    }, playlistStore.progressMeasurementsInterval)
}

onMounted(() => {
    if(props.story)
    {
        const currentNavButton = document.getElementById(props.story.KeyId)
        currentNavButton?.addEventListener("shown.bs.tab", () => {
            const video = document.getElementById(`${props?.story?.KeyId ?? ""}-player`)
            if(video)
            {
                (video as HTMLVideoElement).play()
            }
        })
    } 
})


return (_ctx: any,_cache: any) => {
  return (__props.story)
    ? (_openBlock(), _createElementBlock("li", {
        key: 0,
        id: __props.story.KeyId + '-nav-item',
        class: "nav-item playlist-nav-item"
      }, [
        _createElementVNode("button", {
          class: _normalizeClass(["nav-link nav-link-button", __props.story == __props.stories?.at(0) ? 'active' : '']),
          id: __props.story.KeyId,
          ref_key: "tabsButtons",
          ref: tabsButtons,
          "data-bs-toggle": "tab",
          "data-bs-target": `#${__props.story.KeyId}-toggle`,
          type: "button",
          role: "tab",
          "aria-controls": `${__props.story.KeyId}-toggle`,
          "aria-selected": __props.story == __props.stories?.at(0) ? true : false,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (SetTimerCycle(__props.story))),
          "data-story-type": __props.story.Type
        }, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                ((__props.story.Type == _unref(STORY_TYPE).Video || __props.story.Type == _unref(STORY_TYPE).Audio))
                  ? (_openBlock(), _createElementBlock("progress", {
                      key: 0,
                      id: __props.story.KeyId + '-progress',
                      max: "100",
                      value: "0"
                    }, "Progress", 8, _hoisted_5))
                  : _createCommentVNode("", true),
                (__props.story.Type !== _unref(STORY_TYPE).Text && __props.story.PreviewImage.Url)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      src: __props.story.PreviewImage.Url,
                      alt: __props.story.PreviewImage.Alt
                    }, null, 8, _hoisted_6))
                  : (_openBlock(), _createElementBlock("p", {
                      key: 2,
                      style: _normalizeStyle([{"width":"78px","height":"60px"}, {backgroundColor: __props.story.PreviewColor ?? 'inherit'}]),
                      innerHTML: __props.story.PreviewImage.Url
                    }, null, 12, _hoisted_7))
              ]),
              _createElementVNode("div", _hoisted_8, [
                (__props.story.Title)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("p", _hoisted_10, _toDisplayString(__props.story.Title), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("p", null, _toDisplayString(convertTime(__props.story.ViewDuration) ?? convertTime(_unref(PlaylistConstants).DEFAULT_DURATION)), 1)
                ])
              ])
            ])
          ])
        ], 10, _hoisted_2)
      ], 8, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})